<template>
  <div class="container">
    <div class="row white-box main-print text-center">隐私协议</div>
     <div class="row white-box" style="margin-top:20px;white-space: pre-wrap">
    欢迎来到印箱云打印应用
	为了给您提供更准确、更有个性化的服务，我们会按照本隐私权政策的规定使用和披露您的个人信息。但我们将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，我们不会将这些信息对外披露或向第三方提供。我们会不时更新本隐私权政策。 您在同意我们服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于我们服务使用协议不可分割的一部分。
  1. 适用范围
  a) 在您注册印箱云打印帐号时，您根据印箱云打印要求提供的个人注册信息；
  b) 在您使用印箱云打印网络服务，或访问印箱云打印网页时，印箱云打印自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；
  c) 印箱云打印通过合法途径从商业伙伴处取得的用户个人数据。
  您了解并同意，以下信息不适用本隐私权政策：
  a) 您在使用印箱云打印平台提供的搜索服务时输入的关键字信息；
  b) 印箱云打印收集到的您在印箱云打印发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；
  c) 违反法律规定或违反印箱云打印规则行为及印箱云打印已对您采取的措施。
  2. 信息使用
  a) 印箱云打印不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和印箱云打印（含印箱云打印关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。
  b) 印箱云打印亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何印箱云打印平台用户如从事上述活动，一经发现，印箱云打印有权立即终止与该用户的服务协议。
  c) 为服务用户的目的，印箱云打印可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与印箱云打印合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。
  3. 信息披露
  在如下情况下，印箱云打印将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：
  a) 经您事先同意，向第三方披露；
  b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；
  c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
  d) 如您出现违反中国有关法律、法规或者印箱云打印服务协议或相关规则的情况，需要向第三方披露；
  e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；

    </div>
  </div>
</template>

<script>
  export default {
    name: "PageAbout",
    props: ['isLogin'],
    data: function () {
      return {
        mobile : ''
      }
    },
    methods: {
      submit : function () {

      }
    },
    created: function () {
      console.info('page-about-init');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageYS.vue